import React, { useState } from 'react';
import { api } from '../api';

// Yüklenen görselleri gösterir. Görsel uç noktası (/api/gorseller/dosya/...)
// anonim erişime açıktır, bu yüzden doğrudan <img src> yeterlidir.
// Göreli adresler API tabanıyla tamamlanır. Yüklenemezse yer tutucu gösterir.
export default function Gorsel({ url, className, alt = 'görsel', yerTutucu = '—' }) {
  const [hata, setHata] = useState(false);

  if (!url || hata) {
    return (
      <div
        className={className}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#bbb', fontSize: 12 }}
      >
        {yerTutucu}
      </div>
    );
  }

  const tam = /^https?:\/\//i.test(url) ? url : `${api.taban}${url.startsWith('/') ? '' : '/'}${url}`;

  return <img className={className} src={tam} alt={alt} onError={() => setHata(true)} />;
}
